import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let CustomLayout = class CustomLayout extends Vue {
  constructor() {
    super(...arguments);
    this.colorObJ = {
      name: '',
      colorCode: ''
    };
  }
  get localName() {
    const state = this.$store.state.configurator[this.nomeGetComp];
    return state ? state[this.fieldGetterName] : '';
  }
  set localName(value) {
    this.$store.commit(`${this.moduleName}/${this.nameMutation}`, value);
  }
  get localColor() {
    const state = this.$store.state.configurator[this.keyName];
    return state ? state[this.fieldGetterColor] : '';
  }
  set localColor(value) {
    this.$store.commit(`${this.moduleName}/${this.colorMutation}`, value);
  }
  selectColor(color) {
    this.colorObJ = color;
    this.localColor = color.name;
  }
  textClear() {
    this.localName = '';
  }
  hideMobileKeyboardOnReturn() {
    // Implement your method
  }
};
__decorate([Prop()], CustomLayout.prototype, "darkTheme", void 0);
__decorate([Prop()], CustomLayout.prototype, "colors", void 0);
__decorate([Prop()], CustomLayout.prototype, "previewComponent", void 0);
__decorate([Prop()], CustomLayout.prototype, "selectedColor", void 0);
__decorate([Prop()], CustomLayout.prototype, "astaColor", void 0);
__decorate([Prop()], CustomLayout.prototype, "keyName", void 0);
__decorate([Prop()], CustomLayout.prototype, "moduleName", void 0);
__decorate([Prop()], CustomLayout.prototype, "colorMutation", void 0);
__decorate([Prop()], CustomLayout.prototype, "nameMutation", void 0);
__decorate([Prop()], CustomLayout.prototype, "fieldGetterName", void 0);
__decorate([Prop()], CustomLayout.prototype, "fieldGetterColor", void 0);
__decorate([Prop()], CustomLayout.prototype, "nomeGetComp", void 0);
__decorate([Prop()], CustomLayout.prototype, "titlePreview", void 0);
CustomLayout = __decorate([Component], CustomLayout);
export default CustomLayout;